import React, { useRef, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram'
import toJS from '../../../hoc/toJS'
import config from '../../../config.json'
import { requestAllData, programFetchRequest } from '../../../actions';
import { PROGRAM, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_META_MOVIES_ITEMS } from '../../../constants/state'
import getData from '../../../functions/getData.js'
import PageEditAllMoviesPage from '../present/PageEditAllMoviesPage'

const mapDispatchToProps = (dispatch, ownProps) => ({
    onGetProgram: () => {
        dispatch(requestAllData())
        dispatch(push(ownProps.goBackPath))
    },
    onUpdateProgramRedirect: ()  => {
        ownProps.onUpdateProgram()
        dispatch(push(ownProps.goBackPath))
    },
    onFetchProgram: () => {
      dispatch(programFetchRequest())
    }
})

const mapStateToProps = state => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    moviesOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    metaMovies: getData(state, PROGRAM_META_MOVIES_ITEMS),
    hasUpdates: state.getIn([PROGRAM, 'hasUpdates'])
})

const PageEditAllMovies = ({goBackPath = false, movies, moviesOrder, metaMovies, hasUpdates, programStatus, programError, onGetProgram, onFetchProgram,  onUpdateProgramRedirect, onUpdateProgram}) => {
    const listHeaderRef = useRef()
    const [isSticky, setIsSticky] = useState(false)

    const handleScroll = event => {
        const { offsetTop } = listHeaderRef.current

        if(event.currentTarget.scrollTop < offsetTop) {
            if(isSticky) {
                setIsSticky(false)
            }
        } else {
            if(!isSticky)  {
                setIsSticky(true)
            }
        }
    }

    return <PageEditAllMoviesPage
            pageTitleTransId={config.routes.movies.transId}
            goBackPath={goBackPath}
            movies={movies}
            moviesOrder={moviesOrder}
            metaMovies={metaMovies}
            hasUpdates={hasUpdates}
            isSticky={isSticky}
            listHeaderRef={listHeaderRef}
            programStatus={programStatus}
            programError={programError}
            onGetProgram={onGetProgram}
            onUpdateProgram={onUpdateProgram}
            onUpdateProgramRedirect={onUpdateProgramRedirect}
            onFetchProgram={onFetchProgram}
            handleScroll={handleScroll}
        />
}

export default compose(
    hasUpdateProgram(),
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageEditAllMovies)